import angular from 'angular';
import RoleService from './role.service';

let roleModule = angular.module('role', []).service('roleService', RoleService);

export default roleModule;



// WEBPACK FOOTER //
// ./app/common/role/role.js